import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import {
    NavigationLinkDirective,
    ShIconModule,
    ShPageHeaderComponent,
    ShPaginationComponent
} from '@stylehaven/components';
import { DigihavenElementsModule } from '../elements/elements.module';
import { ReadableDatePipeModule } from '../pipes/readable-date-pipe';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { NotificationService } from '../services/notifications/notification.service';
import { SharedModule } from '../shared.module';
import { NotificationDashboardContainerComponent } from './containers/notification-dashboard-container/notification-dashboard-container.component';
import { NotificationsOverviewContainerComponent } from './containers/notification-overview/notification-overview-container.component';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { IsDeleteNotificationPipe } from './pipes/is-delete-notification.pipe';
import { NotificationsSandboxService } from './sandbox/notifications-sandbox.service';

@NgModule({
    declarations: [
        NotificationsOverviewContainerComponent,
        NotificationDashboardContainerComponent,
        IsDeleteNotificationPipe
    ],
    imports: [
        CommonModule,
        NotificationsRoutingModule,
        TranslateModule,
        ReactiveFormsModule,
        ShPageHeaderComponent,
        ShIconModule,
        SharedPipesModule,
        SharedModule,
        DigihavenElementsModule,
        ReadableDatePipeModule,
        NavigationLinkDirective,
        ShPaginationComponent
    ],
    exports: [NotificationDashboardContainerComponent],
    providers: [NotificationsSandboxService, NotificationService]
})
export class NotificationsModule {}
